module.exports = __webpack_public_path__ + "media/images/ic_keywords-6359e6a943b5a746f65915ee206af858.svg";